import ClientsInfo from './ClientsInfo'

export default ClientsInfo
